import styled from "styled-components";
import Button from "./ActionButton";

const HeadlineText = styled.span`
  color: #fff;
  width: 100vw;
  text-align: center;
  font-size: 1.4rem;
  font-weight: 600;
  justify-content: center;
  padding: 1rem 0;
  background-color: #d97706;
  display: flex;
  justify-content: center;
  align-items: center;
  a {
    transition: all 300ms ease-in-out;
    color: #fff;

    &:hover {
      color: #ae5f05;
    }
  }

  ${({ fontSize }) => fontSize && `font-size: ${fontSize}rem;`}
  ${({ marginBottom }) => marginBottom && `margin-bottom: ${marginBottom}rem;`}
`;

export default function Headline({
  text,
  fontSize,
  marginBottom,
  buttonText,
  buttonAction,
}) {
  return (
    <HeadlineText fontSize={fontSize} marginBottom={marginBottom}>
      {text}{" "}
      {buttonText && (
        <Button action={buttonAction} text={buttonText} color={"#fff"} />
      )}
    </HeadlineText>
  );
}
